<template>
  <div>
    <div class="selector-bar">
      <Selector :selector="selector" :place="place"/>
    </div>
    <div class="joblist-wrapper" ref="joblist" >
      <div class="content">
        <ul>
          <li v-for="(item, index) in joblist.list" :key="index" >
            <JobItem :job="item" />
          </li>
        </ul>
        <Loading />
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import JobItem from '@/components/JobItem'
import Selector from '@/components/Selector'
import Loading from '@/components/Loading.vue'
export default {
  props: {
    place: String,
    selector: Array
  },
  data() {
    return {
      joblist: this.$store.state.jobList[this.place],
      scroll: null,
      loading: false
    }
  },
  computed: {
    jobList() {
      return this.$store.state.jobList[this.place]
    }
  },
  watch: {
    // 递归监听joblist变化，更新scroll
    joblist: {
      handler: function() {
        this.$nextTick(()=>{this.scroll.refresh()})
      },
      deep:true
    }
  },
  methods: {
    disableScroll() {
      // console.log('内部停止')
      if(this.scroll.enabled) this.scroll.disable();
    },
    enableScroll() {
      // console.log('内部启动')
      if(!this.scroll.enabled) this.scroll.enable();
    }
  },
  mounted() {
    // 初始化home页为 scroll-wrapper
    this.$nextTick( () => {
      this.scroll = new BScroll(this.$refs.joblist, {
        // stopPropagation: true,
        click: true,
        bounce: {
          top: false
        },
        momentumLimitTime: 250,
        bounceTime: 250,
        pullUpLoad: {
          threshold: 20,
          moreTxt: 'loadMore',
          noMoreTxt: 'no more'
        }
      })

      // 滚动开始时判断，如果当前滚动不为0，则阻止外部滚动
      this.scroll.on('scrollStart', e => {
        if(this.scroll.y < -20) {
          this.$eventBus.emit('homeScrollDiable')
        }
      })

      // 滚动结束时判断，如果当前滚动为0，则允许外部滚动
      this.scroll.on('scrollEnd', e => {
        if(this.scroll.y === 0) {
          this.$eventBus.emit('homeScrollEnable')
        }
      })

      // 上拉翻页
      this.scroll.on('pullingUp', () => {
        // jobListNextPage
        console.log('加载更多')
        this.$store.commit('jobListNextPage', {place: this.place})
        this.$nextTick( () => {
          this.scroll.refresh();
          setTimeout(() => {
            this.scroll.finishPullUp();
          },500)
        })
      })
    })
  },
  created() {
    // 注册总线事件
    this.$eventBus.on('jobRefresh', () => {
      this.$nextTick(() => {
        // 刷新 scroll, 并滚动至顶端
        this.scroll.scrollTo(0, 0)
      })
    })
    
    this.$eventBus.on('recoverHomeScroll', ()=> {
      // 滚动值小于20像素，则允许外部滚动
      if(this.scroll.y > -20) {
        this.$eventBus.emit('homeScrollEnable')
      } else {
        this.$eventBus.emit('homeScrollDiable')
      }
    })
    this.$eventBus.on('jobListScrollEnable', ()=> { this.enableScroll(); })
    this.$eventBus.on('jobListScrollDisable', ()=> { this.disableScroll(); })
    this.$eventBus.on('scrollRefresh', ()=> {this.scroll.refresh()})
    // 初始化列表数据，store.commit('jobListGet', {place})
  },
  components: {
    // Icon, 
    JobItem,
    Selector,
    Loading
  }
}
</script>

<style lang="scss" scoped>
.selector-bar {
  height: 92px;
  position: relative;
  z-index: 100;
}
.joblist-wrapper {
  height: calc(100vh - 92px);
  overflow: hidden;
  ul > li {
    border-bottom: 1px solid #e5e5e5;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>